import {
  Stack,
  TextField,
  useTheme,
  Button,
  Container,
  Typography,
  Paper,
  Grid,
  Dialog,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  DialogTitle,
  DialogActions,
  Snackbar,
  Alert,
  LinearProgress,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Box,
  Divider,
  ToggleButton,
  ToggleButtonGroup,
  Badge,
  Tooltip,
  Fade,
  Card,
  CardContent,
  CardActions,
  InputAdornment,
  Autocomplete,
  Popover,
  CardMedia,
  Switch,
  FormGroup,
  DialogContent,
} from '@mui/material';
import Slide from '@mui/material/Slide';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useRef, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import styled from '@emotion/styled';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import ViewListIcon from '@mui/icons-material/ViewList';
import FilterListIcon from '@mui/icons-material/FilterList';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DescriptionIcon from '@mui/icons-material/Description';
import axios from '../../axios';
import './animation.css';

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
}));

const HeaderPaper = styled(Paper)(({ theme }) => ({
  background: 'linear-gradient(135deg, #134e5e 0%, #71b280 100%)',
  borderRadius: '12px',
  padding: '16px 24px',
  marginBottom: '16px',
  boxShadow: '0 4px 20px rgba(19, 78, 94, 0.3)',
}));

const CompactCard = styled(Card)(({ theme }) => ({
  borderRadius: '10px',
  transition: 'all 0.3s ease',
  border: '1px solid #e8ecf0',
  position: 'relative',
  overflow: 'hidden',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  '&:hover': {
    transform: 'translateY(-3px)',
    boxShadow: '0 8px 25px rgba(0,0,0,0.1)',
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  color: '#fff',
  fontWeight: 700,
  textAlign: 'left',
  backgroundColor: '#1a3a4a',
  padding: '8px 12px',
  whiteSpace: 'nowrap',
  fontSize: '0.75rem',
  letterSpacing: '0.03em',
  borderBottom: '2px solid rgba(255,255,255,0.1)',
  position: 'sticky',
  top: 0,
  zIndex: 10,
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: 'rgba(0, 0, 0, 0.02)',
  },
  '&:hover': {
    backgroundColor: 'rgba(25, 118, 210, 0.04)',
    transition: 'background-color 0.2s ease',
  },
}));

const StickyTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: '70vh',
  '& .MuiTableHead-root': {
    position: 'sticky',
    top: 0,
    zIndex: 10,
  },
}));

const ProductMaster = () => {
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  const theme = useTheme();
  const classes = useStyles();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [open, setOpen] = useState(false);
  const [openAlert, setopenAlert] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [operation, setOperation] = useState('Add');
  const [alertType, setAlertType] = useState('success');
  const [alertMessage, setAlertMessage] = useState('');
  const [openLoader, setOpenLoader] = useState(false);
  const [viewMode, setViewMode] = useState('table');
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilter, setActiveFilter] = useState(null);

  const [ProductName, setProductName] = useState('');
  const [ShortCode, setShortCode] = useState('');
  const [IsActive, setIsActive] = useState('Y');
  const [BrochureFile, setBrochureFile] = useState(null);
  const [CurrentBrochureName, setCurrentBrochureName] = useState('');
  const [BrochureRemoved, setBrochureRemoved] = useState(false);
  const [BrochurePreviewUrl, setBrochurePreviewUrl] = useState('');
  const brochureInputRef = useRef(null);

  const [productData, setProductData] = useState([]);
  const [IdToDelete, setIdToDelete] = useState(null);
  const [editID, setEditID] = useState();

  const [errors, setErrors] = useState({
    ProductName: false,
    ShortCode: false,
    IsActive: false,
  });

  const [helperTexts, setHelperTexts] = useState({
    ProductName: '',
    ShortCode: '',
    IsActive: '',
  });

  useEffect(() => {
    getAllProduct();
  }, []);

  const normalizeProductList = (value) => {
    if (Array.isArray(value)) return value;
    if (value && Array.isArray(value.data)) return value.data;
    return [];
  };

  const getAllProduct = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/getAllProduct', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setProductData(normalizeProductList(res?.data));
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching products:', error);
      setProductData([]);
      setOpenLoader(false);
    }
  };

  const InsertProduct = async (newProduct, isMultipart = false) => {
    try {
      await axios.instance.post('/InsertProduct', newProduct, {
        headers: {
          Authorization: tokent,
          ...(isMultipart ? {} : { 'Content-Type': 'application/json' }),
        },
      });
      getAllProduct();
      setAlertType('success');
      setAlertMessage('New Product Added Successfully!');
      setopenAlert(true);
    } catch (error) {
      console.error('Error adding product:', error);
      setAlertType('error');
      setAlertMessage('Failed to add the Product.');
      setopenAlert(true);
    }
  };

  const UpdateProduct = async (productId, updatedProduct, isMultipart = false) => {
    try {
      await axios.instance.put(`/UpdateProduct/${productId}`, updatedProduct, {
        headers: {
          Authorization: tokent,
          ...(isMultipart ? {} : { 'Content-Type': 'application/json' }),
        },
      });
      setopenAlert(true);
      setEditID();
      getAllProduct();
      setAlertType('success');
      setAlertMessage('Product Updated Successfully!');
    } catch (error) {
      console.error('Error updating product:', error);
      setAlertType('error');
      setAlertMessage('Failed to update the Product.');
      setopenAlert(true);
    }
  };

  const DeleteProduct = async (productId) => {
    try {
      await axios.instance
        .delete(`/DeleteProduct/${productId}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        })
        .then((res) => {
          if (res.data === '') {
            getAllProduct();
            setOpenDelete(false);
            setAlertType('warning');
            setAlertMessage('Product Deleted Successfully!');
            setopenAlert(true);
          } else {
            getAllProduct();
            setOpenDelete(false);
            setAlertType('error');
            setAlertMessage("Oops! Can't delete this data. It's connected to other information.");
            setopenAlert(true);
          }
        });
    } catch (error) {
      console.error('Error deleting product:', error);
      setAlertType('error');
      setAlertMessage('Failed to delete the Product.');
      setopenAlert(true);
    }
  };

  const resetFields = () => {
    setProductName('');
    setShortCode('');
    setIsActive('Y');
    setBrochureFile(null);
    setCurrentBrochureName('');
    setBrochureRemoved(false);
    setBrochurePreviewUrl('');
    if (brochureInputRef.current) {
      brochureInputRef.current.value = '';
    }
    setErrors((prev) => ({ ...prev, ProductName: false, ShortCode: false, IsActive: false }));
    setHelperTexts((prev) => ({ ...prev, ProductName: '', ShortCode: '', IsActive: '' }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const inputValidation = !ProductName || !ShortCode || !IsActive;

    if (inputValidation) {
      if (!ProductName) {
        setErrors((prev) => ({ ...prev, ProductName: true }));
        setHelperTexts((prev) => ({ ...prev, ProductName: 'Please enter product name' }));
      }
      if (!ShortCode) {
        setErrors((prev) => ({ ...prev, ShortCode: true }));
        setHelperTexts((prev) => ({ ...prev, ShortCode: 'Please enter short code' }));
      }
      return;
    }

    const payload = new FormData();
    const trimmedShortCode = ShortCode.trim();
    payload.append('ProductName', ProductName);
    payload.append('ShortCode', trimmedShortCode);
    payload.append('IsActive', IsActive);
    payload.append('CreatedBy', '5');
    payload.append('ModifyedBy', '5');

    if (BrochureRemoved) {
      payload.append('BrochureFileName', '');
    } else if (BrochureFile) {
      payload.append('BrochureFileName', BrochureFile);
    } else if (operation === 'Edit' && CurrentBrochureName) {
      payload.append('BrochureFileName', CurrentBrochureName);
    }

    if (operation === 'Add') {
      InsertProduct(payload, true);
    } else {
      UpdateProduct(editID, payload, true);
    }
    resetFields();
    handleClose();
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'ProductName') setProductName(value);
    if (name === 'ShortCode') setShortCode(value);
    if (name === 'IsActive') setIsActive(value);
    validateInput(name, value);
  };

  const validateInput = (name, value) => {
    let error = false;
    let helperText = '';

    if (name === 'ProductName') {
      if (!value.trim()) {
        error = true;
        helperText = 'Field cannot be empty';
      }
    } else if (name === 'ShortCode') {
      if (!value.trim()) {
        error = true;
        helperText = 'Field cannot be empty';
      } else if (value.trim().length > 20) {
        error = true;
        helperText = 'Short code cannot exceed 20 characters';
      }
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
    setHelperTexts((prev) => ({ ...prev, [name]: helperText }));
  };

  const handleBlur = (event) => {
    const { name, value } = event.target;
    if (value && value.length > 0) {
      validateInput(name, value);
    }
  };

  const handleAddOpen = () => {
    setOpen(true);
    setOperation('Add');
    resetFields();
  };

  const handleEdit = (product) => {
    setEditID(product.ProductID);
    setProductName(product.ProductName);
    setShortCode(product.ShortCode);
    setIsActive(product.IsActive);
    setCurrentBrochureName(product.BrochureFileName || '');
    setBrochureRemoved(false);
    setBrochureFile(null);
    const existingUrl = product.BrochureFileName
      ? `${axios.baseURL}${product.BrochureFileName.replace(/\\/g, '/')}`
      : '';
    setBrochurePreviewUrl(existingUrl);
    setOpen(true);
    setOperation('Edit');
  };

  const handleBrochureChange = (event) => {
    const file = event.target.files && event.target.files[0];
    const maxBrochureSize = 5 * 1024 * 1024;

    if (!file) {
      setBrochureFile(null);
      setBrochureRemoved(false);
      return;
    }

    if (file.type !== 'application/pdf') {
      setAlertType('error');
      setAlertMessage('Only PDF files are allowed for brochure upload.');
      setopenAlert(true);
      event.target.value = '';
      setBrochureFile(null);
      setBrochureRemoved(false);
      setBrochurePreviewUrl('');
      return;
    }

    if (file.size > maxBrochureSize) {
      setAlertType('error');
      setAlertMessage('Brochure file size must not exceed 5 MB.');
      setopenAlert(true);
      event.target.value = '';
      setBrochureFile(null);
      setBrochureRemoved(false);
      setBrochurePreviewUrl('');
      return;
    }

    setBrochureFile(file);
    setCurrentBrochureName(file.name);
    setBrochureRemoved(false);
    setBrochurePreviewUrl(URL.createObjectURL(file));
  };

  const handleRemoveBrochure = () => {
    setBrochureFile(null);
    setCurrentBrochureName('');
    setBrochureRemoved(true);
    setBrochurePreviewUrl('');
    if (brochureInputRef.current) {
      brochureInputRef.current.value = '';
    }
  };

  const handleDelete = (productId) => {
    setOpenDelete(true);
    setIdToDelete(productId);
  };

  const handleDeleteConfirmed = () => {
    DeleteProduct(IdToDelete);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  const handleClose = () => {
    resetFields();
    setOpen(false);
  };

  const handleFilterOpen = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const getFilteredData = () => {
    const safeProducts = normalizeProductList(productData);
    let filtered = safeProducts;

    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((value) => typeof value === 'string' && value.toLowerCase().includes(searchLower))
      );
    }

    if (activeFilter && activeFilter.value !== 'all') {
      filtered = filtered.filter((item) => item.IsActive === activeFilter.value);
    }

    return filtered;
  };

  const filteredData = getFilteredData();

  const clearAllFilters = () => {
    setActiveFilter(null);
    setSearchTerm('');
    handleFilterClose();
  };

  const getActiveFilterCount = () => {
    let count = 0;
    if (activeFilter && activeFilter.value !== 'all') count += 1;
    if (searchTerm) count += 1;
    return count;
  };

  const statusOptions = [
    { label: 'All Status', value: 'all' },
    { label: 'Active', value: 'Y' },
    { label: 'Inactive', value: 'N' },
  ];

  const getBrochureUrl = (product) => {
    if (!product.BrochureFileName) return null;
    return `${axios.baseURL}${product.BrochureFileName.replace(/\\/g, '/')}`;
  };

  const renderCardView = () => {
    return (
      <Grid container spacing={2}>
        {filteredData.map((product) => {
          const brochureUrl = getBrochureUrl(product);
          const hasBrochure = !!brochureUrl;

          return (
            <Grid item xs={12} sm={6} md={4} lg={3} key={product.ProductID}>
              <Fade in timeout={400}>
                <CompactCard>
                  <Box
                    sx={{
                      p: 2,
                      minHeight: 130,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                    }}
                  >
                    <Inventory2Icon sx={{ fontSize: 54, color: 'primary.main' }} />

                    {hasBrochure && (
                      <Tooltip title="Brochure Available">
                        <Chip
                          icon={<PictureAsPdfIcon sx={{ fontSize: 14 }} />}
                          label="PDF"
                          color="error"
                          size="small"
                          sx={{
                            position: 'absolute',
                            top: 6,
                            left: 6,
                            fontWeight: 600,
                            zIndex: 3,
                            bgcolor: '#dc2626',
                            color: '#fff',
                            '& .MuiChip-icon': { color: '#fff' },
                          }}
                        />
                      </Tooltip>
                    )}
                  </Box>

                  <Chip
                    label={product.IsActive === 'Y' ? 'Active' : 'Inactive'}
                    color={product.IsActive === 'Y' ? 'success' : 'error'}
                    size="small"
                    sx={{ position: 'absolute', top: 6, right: 6, fontWeight: 600, zIndex: 3 }}
                  />

                  <CardContent sx={{ pt: 1, pb: 1, flexGrow: 1 }}>
                    <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 700, mb: 1 }}>
                      {product.ProductName}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Short Code: <strong>{product.ShortCode}</strong>
                    </Typography>

                    <Box
                      sx={{
                        mt: 2,
                        p: 1.5,
                        borderRadius: 2,
                        border: '1px solid #e5e7eb',
                        bgcolor: hasBrochure ? '#f8fafc' : '#fff7ed',
                      }}
                    >
                      <Typography
                        variant="caption"
                        sx={{
                          display: 'block',
                          fontWeight: 700,
                          color: hasBrochure ? 'primary.main' : 'warning.main',
                          mb: 1,
                        }}
                      >
                        {hasBrochure ? (
                          <>
                            <PictureAsPdfIcon sx={{ fontSize: 14, mr: 0.5 }} /> Brochure Available
                          </>
                        ) : (
                          'No Brochure'
                        )}
                      </Typography>

                      {hasBrochure ? (
                        <Button
                          size="small"
                          variant="outlined"
                          fullWidth
                          startIcon={<DescriptionIcon />}
                          onClick={() => window.open(brochureUrl, '_blank', 'noopener,noreferrer')}
                        >
                          View PDF
                        </Button>
                      ) : (
                        <Typography variant="caption" color="text.secondary">
                          No PDF uploaded for this product.
                        </Typography>
                      )}
                    </Box>
                  </CardContent>

                  <CardActions sx={{ justifyContent: 'flex-end', pt: 0, pb: 2, px: 2 }}>
                    <Tooltip title="Edit">
                      <IconButton size="small" onClick={() => handleEdit(product)} sx={{ color: 'primary.main' }}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        size="small"
                        onClick={() => handleDelete(product.ProductID)}
                        sx={{ color: 'error.main' }}
                      >
                        <DeleteForeverIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </CardActions>
                </CompactCard>
              </Fade>
            </Grid>
          );
        })}
      </Grid>
    );
  };

  const renderTableView = () => {
    return (
      <Paper sx={{ borderRadius: 3, overflow: 'hidden', border: '1px solid #e8ecf0' }}>
        <StickyTableContainer>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell align="center" sx={{ width: 40 }}>
                  #
                </StyledTableCell>
                <StyledTableCell>Product Name</StyledTableCell>
                <StyledTableCell>Short Code</StyledTableCell>
                <StyledTableCell align="center" sx={{ width: 100 }}>
                  Brochure
                </StyledTableCell>
                <StyledTableCell align="center" sx={{ width: 90 }}>
                  Status
                </StyledTableCell>
                <StyledTableCell align="center" sx={{ width: 110 }}>
                  Actions
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((product, index) => {
                const brochureUrl = getBrochureUrl(product);
                const hasBrochure = !!brochureUrl;

                return (
                  <StyledTableRow key={product.ProductID} sx={{ '&:last-child td': { borderBottom: 0 } }}>
                    <TableCell align="center" sx={{ fontSize: '0.75rem', fontWeight: 500, py: 1 }}>
                      {index + 1}
                    </TableCell>
                    <TableCell sx={{ py: 1 }}>
                      <Typography variant="body2" fontWeight={500} sx={{ fontSize: '0.8rem' }}>
                        {product.ProductName}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ py: 1 }}>
                      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                        {product.ShortCode}
                      </Typography>
                    </TableCell>
                    <TableCell align="center" sx={{ py: 1 }}>
                      {hasBrochure ? (
                        <Tooltip title="Click to view brochure">
                          <Button
                            size="small"
                            variant="text"
                            color="error"
                            startIcon={<PictureAsPdfIcon />}
                            onClick={() => window.open(brochureUrl, '_blank', 'noopener,noreferrer')}
                            sx={{
                              fontSize: '0.65rem',
                              fontWeight: 600,
                              textTransform: 'none',
                              '&:hover': { bgcolor: 'rgba(220, 38, 38, 0.04)' },
                            }}
                          >
                            View PDF
                          </Button>
                        </Tooltip>
                      ) : (
                        <Typography variant="caption" color="text.disabled" sx={{ fontSize: '0.65rem' }}>
                          No PDF
                        </Typography>
                      )}
                    </TableCell>
                    <TableCell align="center" sx={{ py: 1 }}>
                      <Chip
                        icon={
                          product.IsActive === 'Y' ? (
                            <CheckCircleOutlineIcon sx={{ fontSize: 14 }} />
                          ) : (
                            <HighlightOffIcon sx={{ fontSize: 14 }} />
                          )
                        }
                        label={product.IsActive === 'Y' ? 'Active' : 'Inactive'}
                        color={product.IsActive === 'Y' ? 'success' : 'error'}
                        size="small"
                        sx={{ fontWeight: 600, height: 22, fontSize: '0.65rem' }}
                      />
                    </TableCell>
                    <TableCell align="center" sx={{ py: 1 }}>
                      <Tooltip title="Edit">
                        <IconButton
                          size="small"
                          onClick={() => handleEdit(product)}
                          sx={{ color: 'primary.main', p: 0.5 }}
                        >
                          <EditIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          size="small"
                          onClick={() => handleDelete(product.ProductID)}
                          sx={{ color: 'error.main', p: 0.5 }}
                        >
                          <DeleteForeverIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
        </StickyTableContainer>
      </Paper>
    );
  };

  return (
    <>
      <style>{`
        /* Sticky Dialog Styles */
        .sticky-dialog .MuiDialog-paper {
          display: flex;
          flex-direction: column;
          max-height: 95vh;
        }
        .sticky-dialog .MuiDialogContent-root {
          flex: 1 1 auto;
          overflow-y: auto;
          padding: 24px;
        }
        .sticky-dialog .MuiDialogActions-root {
          flex-shrink: 0;
        }
        .sticky-dialog .MuiDialogTitle-root {
          flex-shrink: 0;
        }
      `}</style>

      <Snackbar
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={Slide}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%', borderRadius: 2 }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth="xl" sx={{ pt: 3, pb: 4 }}>
        <HeaderPaper elevation={0}>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center">
            <Stack direction="row" alignItems="center" spacing={1}>
              <Inventory2Icon sx={{ color: 'white' }} />
              <Typography variant="h6" fontWeight={700} color="white" sx={{ letterSpacing: '0.02em' }}>
                Product Master
              </Typography>
            </Stack>
            <Typography variant="caption" color="rgba(255,255,255,0.7)">
              Total: {productData.length} products
            </Typography>
          </Stack>
        </HeaderPaper>

        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          alignItems={{ xs: 'stretch', md: 'center' }}
          sx={{ mb: 3 }}
        >
          <TextField
            placeholder="Search products..."
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ flex: 1, minWidth: { md: 200 } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
              endAdornment: searchTerm && (
                <InputAdornment position="end">
                  <IconButton size="small" onClick={() => setSearchTerm('')}>
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Stack direction="row" spacing={1} alignItems="center">
            <Badge badgeContent={getActiveFilterCount()} color="primary" invisible={getActiveFilterCount() === 0}>
              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={handleFilterOpen}
                size="small"
                sx={{ borderRadius: 2 }}
              >
                Filters
              </Button>
            </Badge>

            <ToggleButtonGroup
              value={viewMode}
              exclusive
              onChange={(e, val) => val && setViewMode(val)}
              size="small"
              sx={{ '& .MuiToggleButton-root': { px: 1.5 } }}
            >
              <ToggleButton value="grid">
                <ViewModuleIcon fontSize="small" />
              </ToggleButton>
              <ToggleButton value="table">
                <ViewListIcon fontSize="small" />
              </ToggleButton>
            </ToggleButtonGroup>

            <Button
              variant="contained"
              startIcon={<PlaylistAddIcon />}
              onClick={handleAddOpen}
              sx={{ borderRadius: 2, boxShadow: 2 }}
            >
              New Product
            </Button>
          </Stack>
        </Stack>

        <Popover
          open={Boolean(filterAnchorEl)}
          anchorEl={filterAnchorEl}
          onClose={handleFilterClose}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          PaperProps={{ sx: { maxWidth: 320, width: '100%', p: 2 } }}
        >
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Filter Products
          </Typography>

          <Stack spacing={2} sx={{ mt: 1 }}>
            <Autocomplete
              size="small"
              options={statusOptions}
              getOptionLabel={(option) => option.label}
              value={activeFilter}
              onChange={(e, newValue) => setActiveFilter(newValue)}
              renderInput={(params) => <TextField {...params} label="Status" size="small" />}
            />

            <Stack direction="row" spacing={1}>
              <Button variant="contained" size="small" fullWidth onClick={clearAllFilters} startIcon={<ClearIcon />}>
                Clear All
              </Button>
              <Button variant="outlined" size="small" fullWidth onClick={handleFilterClose}>
                Apply
              </Button>
            </Stack>
          </Stack>
        </Popover>

        {filteredData.length > 0 && (
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 2 }}>
            Showing {filteredData.length} product{filteredData.length !== 1 ? 's' : ''}
          </Typography>
        )}

        {filteredData.length === 0 ? (
          <Paper sx={{ textAlign: 'center', py: 6, borderRadius: 3 }}>
            <Typography variant="h6" color="text.secondary">
              No products found
            </Typography>
            <Typography variant="body2" color="text.disabled">
              Try adjusting your filters or create a new product
            </Typography>
          </Paper>
        ) : viewMode === 'grid' ? (
          renderCardView()
        ) : (
          renderTableView()
        )}
      </Container>

      {/* Add/Edit Dialog - Redesigned with Sticky Header & Footer */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullScreen={isMobile}
        fullWidth
        className="sticky-dialog"
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: '95vh',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* Sticky Header */}
          <DialogTitle
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              borderBottom: '1px solid #e8ecf0',
              bgcolor: '#fafbfc',
              py: 2,
              pr: 2,
              flexWrap: 'wrap',
              gap: 1,
              flexShrink: 0,
              position: 'sticky',
              top: 0,
              zIndex: 10,
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              {`${operation} Product`}
            </Typography>
            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          {/* Scrollable Content */}
          <DialogContent
            sx={{
              p: 3,
              overflow: 'auto',
              flex: '1 1 auto',
              '&:first-of-type': { pt: 3 },
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Product Name"
                  name="ProductName"
                  value={ProductName}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  fullWidth
                  size="small"
                  error={errors.ProductName}
                  helperText={helperTexts.ProductName}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  label="Short Code"
                  name="ShortCode"
                  value={ShortCode}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  fullWidth
                  size="small"
                  error={errors.ShortCode}
                  helperText={helperTexts.ShortCode}
                />
              </Grid>

              <Grid item xs={12}>
                <Paper
                  variant="outlined"
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    borderStyle: 'dashed',
                    borderColor: BrochurePreviewUrl ? 'primary.main' : 'divider',
                    bgcolor: BrochurePreviewUrl ? '#f8fafc' : '#fff',
                  }}
                >
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    justifyContent="space-between"
                    alignItems={{ xs: 'flex-start', sm: 'center' }}
                    spacing={1}
                  >
                    <Typography variant="subtitle2" fontWeight={700}>
                      Product Brochure (PDF)
                    </Typography>

                    <Stack direction="row" spacing={1}>
                      <Button component="label" variant="outlined" size="small">
                        {BrochureFile || CurrentBrochureName ? 'Replace PDF' : 'Upload PDF'}
                        <input
                          ref={brochureInputRef}
                          hidden
                          accept="application/pdf"
                          title="Maximum file size: 5 MB"
                          type="file"
                          onChange={handleBrochureChange}
                        />
                      </Button>

                      {(BrochureFile || CurrentBrochureName || BrochureRemoved) && (
                        <Button variant="text" color="error" size="small" onClick={handleRemoveBrochure}>
                          Remove
                        </Button>
                      )}
                    </Stack>
                  </Stack>

                  {(BrochureFile || CurrentBrochureName || BrochurePreviewUrl) && !BrochureRemoved ? (
                    <Box sx={{ mt: 2, p: 1.5, borderRadius: 2, bgcolor: '#f8fafc', border: '1px solid #e2e8f0' }}>
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        justifyContent="space-between"
                        alignItems={{ xs: 'flex-start', sm: 'center' }}
                        spacing={1}
                      >
                        <Box>
                          <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                            {BrochureFile ? 'New file selected' : 'Saved brochure'}
                          </Typography>
                          <Typography variant="body2" fontWeight={600} sx={{ wordBreak: 'break-all' }}>
                            {BrochureFile ? BrochureFile.name : CurrentBrochureName}
                          </Typography>
                        </Box>

                        {(BrochurePreviewUrl || (CurrentBrochureName && !BrochureRemoved)) && (
                          <Button
                            size="small"
                            variant="contained"
                            startIcon={<DescriptionIcon />}
                            onClick={() =>
                              window.open(
                                BrochurePreviewUrl || `${axios.baseURL}${CurrentBrochureName.replace(/\\/g, '/')}`,
                                '_blank',
                                'noopener,noreferrer'
                              )
                            }
                          >
                            Preview
                          </Button>
                        )}
                      </Stack>
                    </Box>
                  ) : (
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 2, display: 'block' }}>
                      No brochure uploaded for this product yet.
                    </Typography>
                  )}
                </Paper>
              </Grid>
            </Grid>
          </DialogContent>

          {/* Sticky Footer with Switch and Buttons */}
          <DialogActions
            sx={{
              p: 2,
              borderTop: '1px solid #e8ecf0',
              bgcolor: '#fafbfc',
              gap: 2,
              flexShrink: 0,
              position: 'sticky',
              bottom: 0,
              zIndex: 10,
              flexWrap: 'wrap',
              alignItems: 'center',
            }}
          >
            {/* Left side - Status Switch */}
            <Stack direction="row" spacing={2} alignItems="center">
              <FormGroup row>
                <FormControlLabel
                  control={
                    <Switch
                      checked={IsActive === 'Y'}
                      onChange={(e) =>
                        handleInputChange({ target: { name: 'IsActive', value: e.target.checked ? 'Y' : 'N' } })
                      }
                      color="success"
                      size="small"
                    />
                  }
                  label={
                    <Typography variant="body2" fontWeight={500}>
                      {IsActive === 'Y' ? 'Active' : 'Inactive'}
                    </Typography>
                  }
                />
              </FormGroup>
            </Stack>

            {/* Right side - Action Buttons */}
            <Stack direction="row" spacing={1}>
              <Button variant="outlined" onClick={handleClose} size="medium">
                Cancel
              </Button>
              <Button type="submit" variant="contained" size="medium">
                {operation === 'Add' ? 'Create Product' : 'Update Product'}
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>

      {/* Delete Dialog */}
      <Dialog open={openDelete} onClose={handleCloseDelete} fullWidth maxWidth="xs">
        <DialogTitle sx={{ fontWeight: 600 }}>Delete Product?</DialogTitle>
        <DialogActions sx={{ px: 3, pb: 3 }}>
          <Button variant="outlined" onClick={handleCloseDelete}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleDeleteConfirmed}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      {/* Loader */}
      <Dialog open={openLoader} fullWidth>
        <LinearProgress />
      </Dialog>
    </>
  );
};

export default ProductMaster;
